import { useTranslations } from "next-intl"
import { useNavigationContent } from "@/features/navigation/hooks/useNavigationContent"
import { externalRoutesPaths } from "@/routes/external"
import { onboardingRoutesPaths } from "@/routes/onboarding"
import { storyblokRoutesPaths } from "@/routes/storyblok"
import { type MenuItem } from "../types/menuItem"

/** Hardcoded menu, used until Storyblok has usable content. */
function getDefaultLeftMenu(t: ReturnType<typeof useTranslations>) {
    return [
        {
            label: t("home"),
            href: storyblokRoutesPaths.home.resolve(),
        },
        {
            label: t("meterDetails"),
            href: onboardingRoutesPaths.meterDetails.resolve(),
        },
        {
            label: t("offer"),
            href: storyblokRoutesPaths.landing.resolve({ pathParams: { landingId: "offre" } }),
        },
        {
            label: t("blog"),
            href: storyblokRoutesPaths.blog.resolve(),
        },
        {
            label: t("welcomeToTheJungle"),
            href: externalRoutesPaths.welcomeToTheJungle.resolve(),
        },
        {
            label: t("faq"),
            href: storyblokRoutesPaths.faq.resolve(),
        },
    ] satisfies Array<MenuItem>
}

export function useLeftMenu(): Array<MenuItem> {
    const t = useTranslations("useLeftMenu")
    const { footerLeftMenu } = useNavigationContent()

    return footerLeftMenu.length ? footerLeftMenu : getDefaultLeftMenu(t)
}

useLeftMenu.messages = ["useLeftMenu"] as const
